import React, { useEffect, useState } from 'react';
import { getAchievements } from '../data/translations';
import { useApp } from '../context/AppContext';

export default function AchievementPopup() {
  const { state, dispatch } = useApp();
  const [visible, setVisible] = useState(false);
  const [ach, setAch] = useState(null);
  const lang = state.language || 'en';

  useEffect(() => {
    const justUnlocked = state.achievements?.find(a => a.unlocked && a.justUnlocked);
    if (justUnlocked && !visible) {
      setAch(justUnlocked);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
        setTimeout(() => setAch(null), 400);
      }, 3500);
    }
  }, [state.achievements]);

  if (!ach && !visible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1001, padding: '2rem',
      opacity: visible ? 1 : 0,
      transition: 'opacity 0.3s ease',
    }}>
      <div style={{
        background: 'linear-gradient(145deg, #1A0840, #0D1535)',
        border: '2px solid rgba(255,215,0,0.5)',
        borderRadius: 28,
        padding: '2.5rem 2rem',
        textAlign: 'center',
        maxWidth: 320,
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.8), 0 0 40px rgba(255,215,0,0.2)',
        animation: visible ? 'popIn 0.5s cubic-bezier(0.36,0.07,0.19,0.97)' : 'none',
      }}>
        {/* Glow ring */}
        <div style={{ fontSize: 64, marginBottom: 16, animation: 'levelUp 0.6s ease', display: 'inline-block' }}>
          {ach?.emoji || '🏆'}
        </div>
        <div style={{ fontSize: 11, letterSpacing: 3, color: '#FFD700', fontWeight: 700, marginBottom: 8, textTransform: 'uppercase' }}>
          {lang === 'en' ? '🎉 Achievement Unlocked!' : lang === 'sv' ? '🎉 Prestation upplåst!' : lang === 'da' ? '🎉 Præstation låst op!' : '🎉 Prestasjon låst opp!'}
        </div>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 800, color: '#fff', marginBottom: 8 }}>
          {ach?.name || ''}
        </div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', marginBottom: 20 }}>
          {ach?.desc || ''}
        </div>
        <div style={{
          background: 'rgba(255,215,0,0.15)',
          border: '1px solid rgba(255,215,0,0.3)',
          borderRadius: 999,
          padding: '8px 20px',
          fontSize: 14,
          fontWeight: 700,
          color: '#FFD700',
          display: 'inline-block',
        }}>
          +{ach?.xp || 50} XP
        </div>
      </div>
    </div>
  );
}